import { CSSProperties, useMemo } from 'react';

type PlayerColors = {
  theme?: 'dark' | 'light';
  customPrimaryColor?: string;
  controlBarColor?: string;
  iconColor?: string;
};

export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  yellow: '#FFFF00',
  green: '#00FF00',
  cyan: '#00FFFF',
  blue: '#0000FF',
  magenta: '#FF00FF',
  red: '#FF0000',
};

export const DARK_THEME_COLORS = {
  '--primaryColor': '#009339',
  '--backgroundColor': '#202020',
  '--videoBackground': '#000000',
  '--textColor': '#FFFFFF',
  '--sliderBackgroundColor': 'rgba(255, 255, 255, 0.2)',
  '--labelOverlayColor': 'rgba(32, 32, 32, 0.5)',
  '--overlayBackground': '#202020',
  '--overlayForeground': '#FFFFFF',
  '--borderColor': 'rgba(124, 124, 124, 1)',
  '--hoverBackground': 'rgba(51, 51, 51, 1)',
};

export const LIGHT_THEME_COLORS = {
  '--primaryColor': '#009339',
  '--backgroundColor': '#FFFFFF',
  '--videoBackground': '#EEEEEE',
  '--textColor': '#202020',
  '--sliderBackgroundColor': 'rgba(255, 255, 255, 0.2)',
  '--labelOverlayColor': 'rgba(32, 32, 32, 0.5)',
  '--overlayBackground': '#FFFFFF',
  '--overlayForeground': '#333333',
  '--borderColor': 'rgba(196, 196, 196, 1)',
  '--hoverBackground': 'rgba(245, 245, 245, 1)',
};

export function usePlayerColorsStyles({ theme, customPrimaryColor, controlBarColor, iconColor }: PlayerColors) {
  const styles = useMemo(() => {
    const themeColors = theme === 'light' ? LIGHT_THEME_COLORS : DARK_THEME_COLORS;
    return {
      '--primaryColor': customPrimaryColor || themeColors['--primaryColor'],
      '--backgroundColor': themeColors['--backgroundColor'],
      '--videoBackground': themeColors['--videoBackground'],
      '--textColor': themeColors['--textColor'],
      '--sliderBackgroundColor': themeColors['--sliderBackgroundColor'],
      '--labelOverlayColor': themeColors['--labelOverlayColor'],
      '--overlayBackground': controlBarColor || themeColors['--overlayBackground'],
      '--overlayForeground': iconColor || themeColors['--overlayForeground'],
      '--borderColor': themeColors['--borderColor'],
      '--hoverBackground': themeColors['--hoverBackground'],
    } as CSSProperties;
  }, [controlBarColor, customPrimaryColor, iconColor, theme]);

  return styles;
}
